import { useCallback } from 'react';
import { bridge } from 'shared/src/utils';

type Params = {
  type: string;
  listId: string | undefined;
};

export const useLogClickDeliveryToggle = (params: Params) => {
  return useCallback(
    (isOn: boolean) => {
      bridge.logAnalyticsEvent({
        name: 'CLICK_HEADLINE_XSMALL_ONE_LINE_TOGGLE',
        analytics: {
          SCREEN: params.type.toUpperCase(),
          IS_ON: isOn,
          LIST_ID: params.listId,
          TOGGLE_TYPE: 'today',
        },
      });
    },
    [params.type, params.listId],
  );
};
